import { View } from 'react-native';

import { Floating, Item, List } from './components';

export const NutritionCalculator = {
  Floating,
  Static: View,
  List,
  Item,
};
